import * as HTTP from "./http";
import { IObservation, IObservationStats } from "@/types/data";
import { IListApiReponse } from "@/types/api";
import { Annotation } from "@annotorious/react";
import { IInterval } from "@/components/charts/timespan";


export interface ICreateObservationPayload {
  note: string;
  annotations: Annotation[];
  image: string;
}

export interface IUpdateObservationPayload {
  note?: string;
  annotations?: Annotation[];
}

export function createRackObservation(nurseryId: string, rackId: string, payload: ICreateObservationPayload) {
  return HTTP.post(`/api/v1/nurseries/${nurseryId}/observations/`, {...payload, rack: rackId})
    .then(r => {
      if (r.status === 404) throw new Error("Observation not found.");
      if (!r.ok) throw new Error("Unable to create observation. Please try again.");
      return r.json();
    });
}

export function updateRackObservation(nurseryId: string, observationId: string, payload: IUpdateObservationPayload) {
  if (!navigator.onLine) {
    throw new Error("Unable to update observation. Your device currently offline");
  }

  return HTTP.patch(`/api/v1/nurseries/${nurseryId}/observations/${observationId}`, {...payload})
    .then(r => {
      if (r.status === 404) throw new Error("Observation not found.");
      if (!r.ok) throw new Error("Unable to update observation. Please try again.");
      return r.json();
    });
}


export function getRackObservations(nurseryId: string, rackId: string, page: number = 1): Promise<IListApiReponse<IObservation>> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/observations/?page_size=5&rack=${rackId}&page=${page}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get rack observations.");
      return r.json();
    });
}

export function getObservation(nurseryId: string, observationId: string): Promise<IObservation> {
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/observations/${observationId}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get observation.");
      return r.json();
    });
}

export function getObservationDates(nurseryId: string, queryParams?: URLSearchParams): Promise<IObservationStats[]> {
  const queryString = new URLSearchParams(queryParams).toString();
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/observations/dates/${queryString ? `?${queryString}` : ""}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get observations dates.");
      return r.json();
    });
}

export function getObservationStats(nurseryId: string, interval: IInterval = "day", queryParams?: URLSearchParams): Promise<IObservationStats[]> {
  const queryString = new URLSearchParams(queryParams).toString();
  return HTTP.get(`/api/v1/nurseries/${nurseryId}/observations/stats/${interval}/${queryString ? `?${queryString}` : ""}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to get observations stats.");
      return r.json();
    });
}

export function deleteObservation(nurseryId: string, observationId: string) {
  return HTTP._delete(`/api/v1/nurseries/${nurseryId}/observations/${observationId}`)
    .then(r => {
      if (!r.ok) throw new Error("Unable to delete observation.");
      return;
    });
}
